import * as yup from 'yup';

export const validationSchema = yup.object({
	subscriptionPlan: yup.string().required('Subscription Plan is required'),
	numberOfProductTypes: yup.number().required('Additional Products Types is required'),
	periodStart: yup.string().required('Period Start is required'),
	// dateEnd: yup.date().required('Period End is required'),
});
